import { createContextFactory } from "@devowl-wp/utils";
import { OptionStore } from "./optionStore.js";
import { TreeStore } from "./treeStore.js";
class RootStore {
    static me;
    optionStore;
    treeStore;
    contextMemo;
    get context() {
        return this.contextMemo ? this.contextMemo : this.contextMemo = createContextFactory(this);
    }
    constructor(){
        this.optionStore = new OptionStore(this);
        this.treeStore = new TreeStore(this);
    }
    static get StoreProvider() {
        return RootStore.get.context.StoreProvider;
    }
    static get get() {
        return RootStore.me ? RootStore.me : RootStore.me = new RootStore();
    }
}
const useStores = ()=>RootStore.get.context.useStores();
export { RootStore, useStores };
